var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticStyle: { "font-size": "18px" }, attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md10: "", "offset-md1": "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", color: "primary", dark: "" } },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticStyle: { margin: "0px" },
                  attrs: { flat: "", dark: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [
                  _c("v-icon", [_vm._v("reply")]),
                  _vm._v(_vm._s(_vm.$t("Button.back")) + "\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-toolbar-title",
                {
                  staticClass: "display-2 page_title",
                  attrs: { slot: "extension", "pb-2": "" },
                  slot: "extension",
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticStyle: { "padding-bottom": "10px" },
                      attrs: { "x-large": "", left: "" },
                    },
                    [_vm._v("cloud_download")]
                  ),
                  _vm._v(
                    "\n        Map Layer : " + _vm._s(_vm.name) + "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { xs6: "", "pr-3": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dense: "", dark: "", color: "secondary" } },
                        [_c("v-toolbar-title", [_vm._v("Map Layer")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("v-text-field", {
                            attrs: { label: "Name" },
                            model: {
                              value: _vm.mapLayerData.LayerName,
                              callback: function ($$v) {
                                _vm.$set(_vm.mapLayerData, "LayerName", $$v)
                              },
                              expression: "mapLayerData.LayerName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "DisplayName" },
                            model: {
                              value: _vm.mapLayerData.DisplayName,
                              callback: function ($$v) {
                                _vm.$set(_vm.mapLayerData, "DisplayName", $$v)
                              },
                              expression: "mapLayerData.DisplayName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-switch", {
                            attrs: {
                              label: `ShowLoading : ${_vm.mapLayerData.ShowOnLoad.toString()}`,
                            },
                            model: {
                              value: _vm.mapLayerData.ShowOnLoad,
                              callback: function ($$v) {
                                _vm.$set(_vm.mapLayerData, "ShowOnLoad", $$v)
                              },
                              expression: "mapLayerData.ShowOnLoad",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: { items: _vm.getOrdinal, label: "Ordinal" },
                            model: {
                              value: _vm.mapLayerData.Ordinal,
                              callback: function ($$v) {
                                _vm.$set(_vm.mapLayerData, "Ordinal", $$v)
                              },
                              expression: "mapLayerData.Ordinal",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn_save",
                              attrs: { color: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickSave()
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("done"),
                              ]),
                              _vm._v(
                                _vm._s(_vm.$t("Button.Save")) + "\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", "pl-3": "" } },
                [
                  _c("MapServiceManage", {
                    model: {
                      value: _vm.mapLayerData,
                      callback: function ($$v) {
                        _vm.mapLayerData = $$v
                      },
                      expression: "mapLayerData",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }